var render, staticRenderFns
import script from "./FormValidationMixin.vue?vue&type=script&lang=js&"
export * from "./FormValidationMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850d2de",
  null
  
)

export default component.exports